module.exports = __webpack_public_path__ + "img/badge_color_adv-supports.dbfe40b5.svg";